import type {CheckoutModalDimensions} from '@Components/checkout-flow/checkout-flow.types';

export const RESUBSCRIBE_CONFIRMATION_MODAL_DIMENSIONS: CheckoutModalDimensions = {width: '590px', height: 'auto', mobileHeight: 'auto'};
